import React from 'react';
import CorrelationWidgetBuilder from './CorrelationWidgetBuilder';
import CorrelationWidgetRenderer from './CorrelationWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { CorrelationWidgetConfig } from './types';
import { CORRELATION_SERIES_OPTIONS } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsLeftRight } from '@fortawesome/free-solid-svg-icons';

export { default as CorrelationWidgetBuilder } from './CorrelationWidgetBuilder';
export { default as CorrelationWidgetRenderer } from './CorrelationWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'correlation',
  meta: {
    label: 'Correlation',
    icon: React.createElement(FontAwesomeIcon, { icon: faArrowsLeftRight }),
    description: 'Correlation analysis between two data series with rolling correlation chart',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  dataProvider: {
    widget: 'CORRELATION',
    params: [
      { key: 'series_a', label: 'Variable A Series', defaultValue: 'price', type: 'select', options: CORRELATION_SERIES_OPTIONS },
      { key: 'series_b', label: 'Variable B Series', defaultValue: 'price', type: 'select', options: CORRELATION_SERIES_OPTIONS },
      { key: 'entity_b', label: 'Variable B Ticker', defaultValue: 'SPY', unit: 'ticker', type: 'text', placeholder: 'defaults to SPY' },
      { key: 'horizon', label: 'Horizon', defaultValue: 504, unit: 'trading days', type: 'number', placeholder: '504' },
      { key: 'correlation_window', label: 'Correlation Window', defaultValue: 60, unit: 'trading days', type: 'number', placeholder: '60' },
    ],
  },
  defaultSize: { w: 8, h: 6, minW: 5, minH: 5 },
  defaultConfig: () => ({} as CorrelationWidgetConfig),
  Builder: CorrelationWidgetBuilder,
  Renderer: CorrelationWidgetRenderer,
  Preview,
};
